/**
 * Created by Jie Gao on 2021-02-22.
 */
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";

export class GGGameMode extends GameMode{
    public static readonly FREESPIN_SUPER:string = "SUPER_FREESPIN";
    public static readonly DOUBLE_BOMB:string = "DOUBLE_BOMB";
}